module.exports = __webpack_public_path__ + "media/images/emoticons/appli02-06f36862f269d4bf0c0af77540b141cb.gif";